export default __webpack_public_path__ + "1.17.16/static/media/LibreDataSharecode_SimplifiedChinese.f3c534ca.svg";